import React from 'react';
import ErrorMessage from './ErrorMessage';
import styles from './DynamicFormRenderer.module.css';

const TextInput = ({ question, index, value, onChange, error, isSubmitted }) => {
    return (
        <div className={styles.questionWrapper}>
            <div className={styles.questionHeader}>
                <span className={styles.questionNumber}>Q{index + 1}</span>
                <label className={styles.questionLabel}>
                    {question.text}
                    {question.required && <span className={styles.required}>*</span>}
                </label>
            </div>
            <div className={styles.inputWrapper}>
                <input
                    type={question.type}
                    value={value || ''}
                    onChange={(e) => onChange(question.type === 'number' ? parseInt(e.target.value) || '' : e.target.value)}
                    placeholder={question.placeholder || 'Enter your answer'}
                    min={question.validation?.min}
                    max={question.validation?.max}
                    disabled={isSubmitted}
                    className={`${styles.input} ${error ? styles.inputError : ''} ${isSubmitted ? styles.disabled : ''}`}
                />
                {error && <ErrorMessage message={error} />}
            </div>
        </div>
    );
};

export default TextInput;